import { ErrorHandler } from "@angular/core";
import { createErrorHandler } from "@sentry/angular";

import { tryReloadOnceOnStaleChunk, type StaleChunkReloadDeps } from "./stale-chunk-reload";

/**
 * Issue #47 — wraps the Sentry error handler with the one-time stale-chunk
 * silent reload: the first lazy-chunk failure after a deploy recovers with a
 * single reload and is not reported; every other error goes to Sentry as-is.
 */
export class AppErrorHandler implements ErrorHandler {
  private readonly sentryHandler: ErrorHandler;
  private readonly deps: StaleChunkReloadDeps | undefined;

  constructor(deps?: StaleChunkReloadDeps) {
    this.sentryHandler = createErrorHandler();
    this.deps = deps;
  }

  handleError(error: unknown): void {
    if (tryReloadOnceOnStaleChunk(error, this.deps)) {
      // Recovered by the one-time silent reload — do not double-report to Sentry.
      return;
    }

    this.sentryHandler.handleError(error);
  }
}
